import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Layout } from "./components/Layout";
import { AuthProvider } from "./auth/AuthContext";
import { RequireAuth } from "./auth/RequireAuth";
import { CategoriasProvider } from "./categorias/CategoriasContext";

// Cada página se descarga sólo cuando el usuario entra en ella. Así la carga
// inicial no incluye ni las gráficas (recharts) ni el parser de Excel (xlsx),
// que son con diferencia lo más pesado del bundle.
const LoginPage = lazy(() => import("./pages/LoginPage").then((m) => ({ default: m.LoginPage })));
const DashboardPage = lazy(() => import("./pages/DashboardPage").then((m) => ({ default: m.DashboardPage })));
const IngresosPage = lazy(() => import("./pages/IngresosPage").then((m) => ({ default: m.IngresosPage })));
const GastosPage = lazy(() => import("./pages/GastosPage").then((m) => ({ default: m.GastosPage })));
const FacturasPage = lazy(() => import("./pages/FacturasPage").then((m) => ({ default: m.FacturasPage })));
const ComisionesPage = lazy(() => import("./pages/ComisionesPage").then((m) => ({ default: m.ComisionesPage })));
const UsersPage = lazy(() => import("./pages/UsersPage").then((m) => ({ default: m.UsersPage })));
const CategoriasPage = lazy(() => import("./pages/CategoriasPage").then((m) => ({ default: m.CategoriasPage })));

function PageFallback() {
  return <div className="loading">Cargando…</div>;
}

export function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CategoriasProvider>
          <Suspense fallback={<PageFallback />}>
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route
                element={
                  <RequireAuth>
                    <Layout />
                  </RequireAuth>
                }
              >
                <Route path="/" element={<DashboardPage />} />
                <Route path="/ingresos" element={<IngresosPage />} />
                <Route path="/gastos" element={<GastosPage />} />
                <Route path="/facturas" element={<FacturasPage />} />
                <Route path="/comisiones" element={<ComisionesPage />} />
                <Route
                  path="/usuarios"
                  element={
                    <RequireAuth adminOnly>
                      <UsersPage />
                    </RequireAuth>
                  }
                />
                <Route
                  path="/configuracion/categorias"
                  element={
                    <RequireAuth adminOnly>
                      <CategoriasPage />
                    </RequireAuth>
                  }
                />
              </Route>
            </Routes>
          </Suspense>
        </CategoriasProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
